import { render, staticRenderFns } from "./Cm-section-body.vue?vue&type=template&id=3695451e"
import script from "./Cm-section-body.vue?vue&type=script&lang=js"
export * from "./Cm-section-body.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports